// eslint-disable-next-line @typescript-eslint/ban-ts-comment
//@ts-nocheck

export const isOptionEqualToValue = (option, value) => {
  if (typeof value === 'string') {
    return value === option.referenceId || value === option.id;
  }
  if (typeof value === 'object' && value !== null) {
    return value.referenceId === option.referenceId || value.id === option.id;
  }
  return false;
};
